import Image from '@atoms/Image/Image';
import Text from '@atoms/Text/Text';
import { IImage } from '@models/IImage';
import ThemeEnum from '@models/enums/ThemeEnum';
import classNames from 'classnames';

export interface IAuthorBlock {
  readonly author: string;
  readonly authorPosition: string;
  readonly largeImageOnDesktop?: boolean;
  readonly image?: IImage;
  readonly large?: boolean;
  readonly theme?: ThemeEnum;
}

const AuthorBlock = ({
  author,
  authorPosition,
  largeImageOnDesktop,
  image,
  theme = ThemeEnum.Light,
}: IAuthorBlock) => (
  <div
    className={classNames('author-block tw-flex tw-shrink-0 tw-gap-xs', {
      'xxl:tw-max-w-[180px] xxl:tw-flex-col': largeImageOnDesktop,
    })}
  >
    {image && (
      <div
        className={classNames('tw-h-[74px] tw-w-[74px] tw-shrink-0', {
          ' xxl:tw-h-[225px] xxl:tw-w-[180px]': largeImageOnDesktop,
        })}
      >
        <Image
          classes={classNames('tw-object-cover', {
            'xxl:tw-hidden ': largeImageOnDesktop,
          })}
          imageClasses="tw-object-cover"
          image={image}
          aspectRatio={1}
          width={74}
        />
        {largeImageOnDesktop && (
          <Image
            classes="max-xxl:tw-hidden tw-object-cover"
            imageClasses="tw-object-cover"
            width={180}
            aspectRatio={0.8}
            image={image}
          />
        )}
      </div>
    )}
    <div
      className={classNames(
        image ? 'tw-col-span-3' : 'tw-col-span-4',
        theme === ThemeEnum.Dark ? 'tw-text-white' : 'tw-text-grey-80',
        'tw-flex tw-flex-col tw-justify-center'
      )}
    >
      <Text variant="body-14-semibold">{author}</Text>
      <Text variant="body-small">{authorPosition}</Text>
    </div>
  </div>
);

export default AuthorBlock;
